<div [ngClass]="{ 'wrap-drug-name': wrapDrugName }">
  {{ candidate.drugDescription }}
  @if (showCopy) {
    <app-copy-to-clipboard [text]="candidate.drugDescription" />
  }
</div>
<div class="small">
  <strong>NDC:</strong> {{ candidate.ndc }} @if (isFlaggedForEsp) {
  <span class="flagged-for-esp p-1">ESP</span>
}
@if (showCopy) {
  <app-copy-to-clipboard [text]="candidate.ndc" />
}
</div>
